import React from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {PermissionsChecker} from '@client/permissions-checker'
import {Sync} from '@client/sync'
import {ChatSystemMessage} from '@components/common/base/chat-system-message'
import {ReferencedUser} from '@components/right-panel/chat/chat-messages/message/referenced-user'
import {SystemMessageProps} from '@components/right-panel/chat/chat-messages/message/types'
import {getPath} from '@components/statistics/stats-timeline/utils/utils'

interface MessageContentProps {
  from: DataObjectId
  to: DataObjectId
  by: DataObjectId
}

const MessageContent = ({from, to, by}: MessageContentProps) => {
  const box = Sync.getCurrentSandbox()
  const hierarchy = DepartmentsClient.getHierarchy(box)

  const objFrom = box.getHub(from)
  const objTo = box.getHub(to)
  if (!objFrom && !objTo) {
    return <>???</>
  }

  // Same as tile.tsx, ObjectName/getHint, 'move' case
  const fromPath = PermissionsChecker.checkShow(hierarchy, objFrom, {})
    ? getPath({obj: objFrom, box, withName: true})
    : Lang.msg.statsTimeline.inaccessibleLocation
  const toPath = getPath({obj: objTo, box, withName: true})

  return (
    <>
      {Lang.msg.chat.moveInfoPrefix} <ReferencedUser userId={by} guestId={by} />{' '}
      {Lang.msg.chat.moveInfoInfix1}{' '}
      <span className="font-semibold">{`“${fromPath}”`}</span>{' '}
      {Lang.msg.chat.moveInfoInfix2}{' '}
      <span className="font-semibold">{`“${toPath}”`}</span>
    </>
  )
}

export const MoveSystemMessage = ({
  message,
  className,
  animateShow
}: SystemMessageProps) => {
  const from = message.properties.from as DataObjectId
  const to = message.properties.to as DataObjectId
  const by = message.properties.actionBy as DataObjectId

  return (
    <ChatSystemMessage
      type="info"
      layout="vertical"
      content={<MessageContent from={from} to={to} by={by} />}
      dateTime={Time.formatDateTime(message.timestamp)}
      timestamp={message.timestamp}
      className={className}
      animateShow={animateShow}
    />
  )
}
